export default {
    loading: "Wird geladen"
}